import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Remove({
  attributes = {
    color: "",
    classes: "",
    size: "24",
  },
  clickHandler,
}) {
  const navigate = useNavigate();

  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 22.75 22.75"
      >
        <g
          id="Icon_park-add-one"
          data-name="Icon park-add-one"
          transform="translate(-2.5 -2.5)"
        >
          <path
            id="Path_11563"
            data-name="Path 11563"
            d="M13.875,24.75A10.875,10.875,0,1,0,3,13.875,10.875,10.875,0,0,0,13.875,24.75Z"
            fill="none"
            stroke={attributes.color}
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_11564"
            data-name="Path 11564"
            d="M12,16.35h8.7"
            transform="translate(-2.475 -2.475)"
            fill="none"
            stroke={attributes.color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </svg>
    </div>
  );
}
